import React from "react";
import AttachFileIcon from "@material-ui/icons/CloudUpload";
import styles from "./styles";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";

const UploadButtons = props => {
  const { classes, className, style } = props;

  return (
    <div className="buttons fadein" className={classes.buttonsFadeIn}>
      <div className={classes.uploadButton}>
        <input
          type="file"
          accept={props.accepts}
          id="single"
          className={classes.uploadInput}
          onChange={props.onChange}
          disabled={props.disabled}
        />
        <input type="text" className={classes.uploadOverlay} />
        <label htmlFor="single" className={classes.uploadLabel}>
          <AttachFileIcon fontSize="large" />
          <div>For upload click here or drop the file</div>
        </label>
      </div>
    </div>
  );
};

UploadButtons.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  style: PropTypes.object
};

export default withStyles(styles)(UploadButtons);
